<template>
  <span :class="badgeClasses">
    <slot />
  </span>
</template>
<script>
    export default {
        name: "BBadge",
        props: {
            variant: {
                type: String,
                default: "primary",
            },
            pill: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            badgeClasses() {
                return {
                    badge: true,
                    [`badge-${this.variant}`]: true,
                    "badge-pill": this.pill,
                };
            },
        },
    };
</script>